import { PMCategoryProgressCard } from "@pimo/pimo-components/src/lib/pm-components";

import { DashboardCardContext } from "../context";

export function addCompletedProjectsCategoryCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const completedProjectsCategoryComponent = view.addComponent({
    component: PMCategoryProgressCard,
    layoutProps: {
      componentId: "completedProjectsCategoryComponent",
      title: "",
      description: "",
      labels: ["progress"],
    },
  });

  completedProjectsCategoryComponent.mapLayoutProps(
    ({ language, settings }) => {
      const currentLanguage = language || "en";
      const categoryLabel = settings?.configuration?.fieldsDefinition?.find(
        (field) => field.fieldName === "category"
      )?.label;
      const copy = getCardCopy(currentLanguage, "completedProjectsByCategory", {
        categoryLabel,
      });

      return {
        componentId: "completedProjectsCategoryComponent",
        labels: ["progress"],
        title: copy.title,
        description: copy.description,
      };
    }
  );
  completedProjectsCategoryComponent.mapState(
    ({ dashboard, settings, language }) => {
      const currentLanguage = language || "en";
      const categoryLabel = settings?.configuration?.fieldsDefinition?.find(
        (field) => field.fieldName === "category"
      )?.label;
      const copy = getCardCopy(currentLanguage, "completedProjectsByCategory", {
        categoryLabel,
      });
      const existingCategories =
        settings?.configuration?.categoryDefinition?.map((cat) => cat.name) ??
        [];

      return {
        label: copy.title,
        title: copy.title,
        data: existingCategories.map((category) => {
          const completed =
            dashboard?._calculated?.categoryCountsForCompletedProjects?.find(
              (catCount) => catCount.label === category
            )?.value ?? 0;
          const total =
            dashboard?.projects?.filter((p) => p.category === category)
              .length ?? 0;
          return {
            label: category,
            value: completed,
            total,
            color: "#38BDF8",
          };
        }),
        showInfoIcon: false,
        showMenuIcon: false,
      };
    }
  );

  completedProjectsCategoryComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectBasic")
        .find((field) => field.fieldName === "category")?.enabled === true
  );
}
